// extracted by mini-css-extract-plugin
export default {"withdraw_title-text":"withdraw_withdraw_title-text__6wdKE"};